import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TierFormPage } from './tier-form.page';

const routes: Routes = [
  {
    path: '',
    component: TierFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TierFormPageRoutingModule {}
